var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slider',_vm._b({staticClass:"vuestic-slider",attrs:{"value":_vm.value,"interval":_vm.sliderOptions.interval,"bg-style":_vm.sliderOptions.bgStyle,"slider-style":_vm.sliderOptions.sliderStyle,"disabled":_vm.disabled,"lazy":true},on:{"input":_vm.change,"dragend":_vm.changeEnd,"dragover":_vm.changeEnd}},'slider',_vm.sliderOptions,false))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab1f28d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuestic-theme/vuestic-components/vuestic-slider/VuesticSlider.vue
// module id = bJFf
// module chunks = 35